/* Diamond Domain - product page layout (Sep 2026).

   ORDER OF THE COLUMN: name, the full title, the SKU, the rating, the offer if there is one,
   stock and spec, the choices, then the price directly above the button.

   NOTHING IS MOVED INTO THE META ROW. It holds only two spans this file creates; dd-metarow.js
   copies text into them. Four earlier attempts moved the theme's own elements in there and
   every one of them rendered on separate lines - the moved elements carry the theme's display
   and width rules and no amount of !important on the container beat that reliably. The
   sources are parked off screen instead (NOT display:none, because innerText returns nothing
   for a hidden element, and innerText is how the live value is read).

   The review badge is left exactly where the theme puts it. It is a third-party app block
   whose width is outside our control.

   This file also owns the re-render watch. Choosing a metal makes the theme replace
   <variant-selects> wholesale, which destroys the group headings, every metal name and the
   shape switcher outright. Each module registers an idempotent run on window.__ddInit and
   they are all replayed whenever the form's subtree changes.

   Delete this file and its line in layout/theme.liquid to revert. */
(function () {
  function tidy(s) { return (s || '').replace(/\s+/g, ' ').trim(); }

  function park(el) {
    if (!el) return;
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    el.style.top = '0';
    el.setAttribute('aria-hidden', 'true');
  }

  function shortTitle(full) {
    var t = ' ' + tidy(full) + ' ';
    t = t.replace(/\blab[-\s]?grown\b/ig, ' ');
    t = t.replace(/\bengagement\b/ig, ' ');
    t = t.replace(/\bwedding\b/ig, ' ');
    t = t.replace(/\banniversary\b/ig, ' ');
    t = t.replace(/\bdiamonds?\b/ig, ' ');
    t = t.replace(/\bsettings?\b/ig, ' ');
    t = t.replace(/\s+with\s+/ig, ' | ');
    t = t.replace(/\s+with\s*$/i, ' ');
    t = t.replace(/\s+rings?\s*(\||$)/ig, ' $1');
    t = t.replace(/\s*\|\s*$/, ' ');
    t = t.replace(/\s*\|\s*/g, ' · ');
    return tidy(t);
  }

  /* SEO: THE H1 IS NOT REWRITTEN. These pages have been indexed for two years and the H1 is a
     ranking signal on every one of them. The short name is inserted ABOVE the H1 as display
     text and the H1 is styled down, so the page reads the same and the crawled markup does
     not change. <title> and the meta description were always server-rendered. */
  function nameTheRing(col) {
    var h1 = col.querySelector('h1.product__title');
    if (!h1 || h1.dataset.ddNamed === '1') return;

    var full = tidy(h1.textContent);
    var short = shortTitle(full);
    if (!short || short.length < 6 || short.length > 60 || short.length >= full.length) return;

    var name = document.createElement('p');
    name.className = 'dd-name';
    name.setAttribute('aria-hidden', 'true');   /* the H1 below already announces the product */
    name.textContent = short;

    h1.insertAdjacentElement('beforebegin', name);
    h1.classList.add('dd-title--sub');
    h1.dataset.ddNamed = '1';
  }

  /* The theme printed the SKU nowhere at all. It changes with metal and carat, so it is read
     from the map dd-sku.liquid renders and re-read whenever the form changes. */
  function placeSku(col) {
    var sku = document.getElementById('dd-sku');
    if (!sku) return;

    var map = {};
    var raw = document.getElementById('dd-sku-map');
    if (raw) { try { map = JSON.parse(raw.textContent); } catch (e) { map = {}; } }

    var value = sku.querySelector('[data-dd-sku-value]');
    var form = col.querySelector('form.shopify-product-form');

    if (sku.dataset.ddPlaced !== '1') {
      var anchor = col.querySelector('h1.product__title') ||
                   col.querySelector('.product__block--title');
      if (!anchor) return;
      anchor.insertAdjacentElement('afterend', sku);
      sku.hidden = false;
      sku.dataset.ddPlaced = '1';
    }

    function sync() {
      var input = form && form.querySelector('[name="id"]');
      var id = input ? input.value : new URLSearchParams(location.search).get('variant');
      var s = id && map[id];
      if (s && value) value.textContent = s;
    }

    sync();
    if (form && form.dataset.ddSkuBound !== '1') {
      form.addEventListener('change', function () { setTimeout(sync, 60); });
      form.dataset.ddSkuBound = '1';
    }
  }

  /* Park the theme's stock badge and spec line off screen and mark them as the sources
     dd-metarow.js reads. Runs on EVERY replay, not just the first: choosing a carat or metal
     makes the theme redraw its stock badge, and the fresh copy arrives unparked and unmarked.
     Left alone it showed "Hurry! Low inventory" a second time under our own row, and the row
     stopped following the selected variant. */
  function parkSources(col) {
    var row = col.querySelector('.dd-meta');
    if (!row) return;

    if (row.querySelector('.dd-stock')) {
      [].forEach.call(col.querySelectorAll('.variant__countdown:not([data-dd-stock-src])'), function (el) {
        el.setAttribute('data-dd-stock-src', '');
        park(el);
      });
    }

    if (row.querySelector('.dd-spec')) {
      [].forEach.call(col.querySelectorAll('.product__features .product__feature:not([data-dd-spec-src])'), function (el) {
        el.setAttribute('data-dd-spec-src', '');
        park(el.closest('.product__features') || el);
      });
    }
  }

  /* Build an EMPTY row of two spans and park the sources off screen. dd-metarow.js fills it. */
  function buildMeta(col) {
    if (col.querySelector('.dd-meta')) return;

    var countdown = col.querySelector('.variant__countdown');
    var feature = col.querySelector('.product__features .product__feature');
    if (!countdown && !feature) return;

    /* sit below the rating if there is one: name, title, sku, stars, row */
    var badge = col.querySelector('.product__block.standard__app');
    var anchor = badge || col.querySelector('.product__block--title');
    if (!anchor) return;

    var row = document.createElement('div');
    row.className = 'product__block dd-meta';
    anchor.insertAdjacentElement('afterend', row);

    if (countdown) {
      var stock = document.createElement('span');
      stock.className = 'dd-stock';
      row.appendChild(stock);
    }

    if (feature) {
      var spec = document.createElement('span');
      spec.className = 'dd-spec';
      row.appendChild(spec);
    }

    parkSources(col);
  }

  /* The hook goes where an ad click lands. Everything after the countdown - the deadline in
     words, the final-sale terms - is fine print, and fine print belongs at the price. */
  function placeDeal(col, price) {
    var deal = col.querySelector('.dd-deal');
    if (!deal || deal.dataset.ddPlaced === '1') return;

    var timer = deal.querySelector('.dd-deal-timer');
    if (timer && price && price.parentNode) {
      var trailing = [];
      var n = timer.nextElementSibling;
      while (n) { trailing.push(n); n = n.nextElementSibling; }

      if (trailing.length) {
        var terms = document.createElement('div');
        terms.className = 'dd-deal-terms';
        trailing.forEach(function (el) { terms.appendChild(el); });
        price.parentNode.insertBefore(terms, price);
      }
    }

    var anchor = col.querySelector('.dd-meta') || col.querySelector('.product__block--title');
    if (anchor) anchor.insertAdjacentElement('afterend', deal);

    deal.dataset.ddPlaced = '1';
  }

  /* A column TALLER than the screen cannot simply pin its top - everything below the fold
     would be permanently unreachable. It scrolls up until its own bottom meets the bottom of
     the screen, and sticks there. */
  function stickColumn(col) {
    var lastH = -1;
    var headroom = 96;

    function apply() {
      var h = col.offsetHeight;
      if (h === lastH) return;
      lastH = h;
      var vh = window.innerHeight;
      col.style.position = 'sticky';
      col.style.top = (h + headroom + 24 <= vh) ? headroom + 'px' : (vh - h - 24) + 'px';
    }

    apply();
    window.addEventListener('resize', function () { lastH = -1; apply(); });
    if (window.ResizeObserver) new ResizeObserver(apply).observe(col);
  }

  function run() {
    var col = document.querySelector('product-sticky.form__wrapper');
    if (!col) return false;

    if (col.dataset.ddPdp === '1') {
      parkSources(col);
      placeSku(col);
      return true;
    }

    var price = col.querySelector('.product__price-and-badge');
    var form = col.querySelector('form.shopify-product-form');
    if (!price || !form) return false;

    nameTheRing(col);
    buildMeta(col);
    placeSku(col);

    var anchor = form.querySelector('.shop-pay-terms') ||
                 form.querySelector('.product__submit__holder');
    if (anchor && anchor.parentNode) {
      price.classList.add('dd-price--at-cta');
      anchor.parentNode.insertBefore(price, anchor);
    }

    placeDeal(col, price);

    hideZero(price);
    new MutationObserver(function () { hideZero(price); })
      .observe(price, { childList: true, subtree: true, characterData: true });

    if (window.matchMedia('(min-width: 1024px)').matches) stickColumn(col);

    col.dataset.ddPdp = '1';
    return true;
  }

  /* "$0" is not a price - it comes from an unset compare_at value */
  function hideZero(scope) {
    scope.querySelectorAll('*').forEach(function (el) {
      if (el.children.length) return;
      if (/^\$0(\.00)?$/.test(el.textContent.trim())) el.style.display = 'none';
    });
  }

  function replayAll() {
    (window.__ddInit || []).forEach(function (fn) {
      try { fn(); } catch (e) { /* one module must not stop the others */ }
    });
  }

  function watch() {
    var host = document.querySelector('product-info.product-single__wrapper') ||
               document.querySelector('.product__form__wrapper');
    if (!host || host.dataset.ddWatch === '1') return;
    host.dataset.ddWatch = '1';

    var busy = false;
    var timer = null;

    new MutationObserver(function () {
      if (busy) return;
      clearTimeout(timer);
      timer = setTimeout(function () {
        busy = true;
        replayAll();
        setTimeout(function () { busy = false; }, 60);
      }, 120);
    }).observe(host, { childList: true, subtree: true });
  }

  (window.__ddInit = window.__ddInit || []).push(run);

  function start() {
    run();
    watch();
    var tries = 0;
    var timer = setInterval(function () {
      if ((run() && document.querySelector('[data-dd-watch]')) || ++tries > 24) {
        clearInterval(timer);
      }
      watch();
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
